import { HiBookOpen, HiHome, HiLogout, HiUser } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import '../../styles/SideNavBar.css';

const SideNavBar = ({
  activeTab,
  onTabChange,
  onLogout,
  currentUser
}) => {
  const navigationItems = [
    {
      id: 'home',
      label: 'Home',
      icon: HiHome,
      path: '/'
    },
    {
      id: 'all-courses',
      label: 'All Courses',
      icon: HiBookOpen,
      path: '/dashboard'
    },
    {
      id: 'my-courses',
      label: 'My Courses',
      icon: HiBookOpen,
      path: '/my-courses'
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: HiUser,
      path: '/profile'
    }
    // Future navigation items can be added here:
    // {
    //   id: 'categories',
    //   label: 'Categories',
    //   icon: HiFolder
    // },
    // {
    //   id: 'courses',
    //   label: 'My Courses',
    //   icon: HiBookOpen
    // }
  ];

  return (
    <div className="side-navbar">
      {/* Logo Section */}
      <div className="navbar-logo">
        <img
          src="/images/Somayya-Academy-Logo-for-Website-Home.001.png"
          alt="Somayya Academy"
        />
      </div>

      {/* Navigation Items */}
      <nav className="navbar-nav">
        {navigationItems.map((item) => {
          const IconComponent = item.icon;

          return (
            <Link
              key={item.id}
              to={item.path}
              state={{ activeTab: item.id }}
              onClick={() => onTabChange(item.id)}
              className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
            >
              <IconComponent className="nav-icon" />
              <span className="nav-label body3">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* Logout Section */}
      <div className="navbar-logout">
        <button onClick={onLogout} className="logout-btn">
          <HiLogout className="logout-icon" />
          <span className="logout-label body3">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default SideNavBar;
